import React from 'react';
import { hidePopup } from '../../../helpers/uiFunctions/uiActions';

class ClientMap extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    render() {
        return(
            <section className="section">
                <form className="form popup-form" id="clientMap" style={{display: 'none'}}>
                    <i className="fas fa-times icon" onClick={() => hidePopup("clientMap")} style={{float: 'right'}}></i>
                    <iframe src="https://www.google.com/maps/d/embed?mid=1oLp3Sg_MVV5dcoVNw__YGLd1YdQJDD0&ehbc=2E312F" width="700" height="550" title="Mobile Marketing Client Map"></iframe>
                    {/* <iframe src="https://www.google.com/maps/d/u/0/edit?mid=1oLp3Sg_MVV5dcoVNw__YGLd1YdQJDD0&ll=39.03918538530922%2C-98.85225142262095&z=5" width="700" height="550" title="Mobile Marketing Client Map"></iframe> */}
                    <p>Currently maintained in google maps. Contact Dave G for updates.</p>
                </form>
            </section>
        )
    }
}
export default ClientMap;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientExplorer/ClientMap.js